<template>
  <div class="province" v-show="provinceModal">
    <ul>
      <li v-for="item in provinceData" :class="{active:item.show}" @click="activeItem(item)">{{item.name}}</li>
    </ul>
  </div>
</template>
<style scoped lang="less">
@import url('../../assets/less/common.less');
.province{
  width: 100%;
  // height: 5.2rem;
  background: rgba(0,0,0,.8);
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999999;
  overflow: hidden;
  padding: 0.2rem;
  box-sizing: border-box;
  li{
    width: 0.906667rem;
    height: 0.906667rem;
    float: left;
    .px2px(font-size,34px);
    padding: 0.133333rem;
    margin: 0.133333rem;
    box-sizing: border-box;
    border: 1px solid #fff;
    border-radius: 0.08rem;
    color:#fff;
    text-align: center;
    &.active{
      border-color:#ff3938;
      color:#ff3938;
    }
  }
}
</style>
<script>
export default{
  name:'province',
  data () {
    return {
      provinceData: []
    }
  },
  props:['provinceModal'],
  mounted:function(){
    var self = this;
    //确保重要依赖的js加载完成
    getCommonJsIns.initJSNEW(this.webReady);
  },
  methods:{
    webReady:function(){
      this.init();
    },
    init:function(){
      var self = this;
      self.ajaxSubmit.ajax({
        url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.violateCityAbbrList,
        type:"get",
        success:function(data){
          // console.log(data);
          if(data.responseHeader.status==200){
            var abbrData = data.response.result;
            for(var i=0;i<abbrData.length;i++){

              self.provinceData.push({id:i,name:abbrData[i],show:false}); 
            }
          }
          
        },
        error:function(res){
          console.log(res);
        }
      })
    },
    activeItem:function(item){
      for(var i=0;i<this.provinceData.length;i++){
        this.provinceData[i]["show"] = false;
      };
      this.provinceData[item.id]["show"] = true;
      this.$emit('childActiveItem',item);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/violation/province.vue